import { render, staticRenderFns } from "./VerificationFormCommonRisk.vue?vue&type=template&id=d6a10a2e&"
import script from "./VerificationFormCommonRisk.vue?vue&type=script&lang=js&"
export * from "./VerificationFormCommonRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports